import { render, staticRenderFns } from "./UnternehmenList.vue?vue&type=template&id=38a74393&scoped=true&"
import script from "./UnternehmenList.vue?vue&type=script&lang=ts&"
export * from "./UnternehmenList.vue?vue&type=script&lang=ts&"
import style0 from "./UnternehmenList.vue?vue&type=style&index=0&id=38a74393&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a74393",
  null
  
)

export default component.exports